import LensEditorHeader from "routes/lens-editor/LensEditorHeader";
import { Outlet } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import ProfileBuilderHeader from "routes/lens-editor/profile-builder/ProfileBuilderHeader";
import { useAppSelector } from "redux/hooks";
import { selectLensEditorForm } from "redux/slices/lensEditor";
import ProfileBuilderFieldOutline from "./ProfileBuilderOutline";

const ProfileBuilderRoot = () => {
  const form = useAppSelector(selectLensEditorForm);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", p: 2 }}>
      <LensEditorHeader />
      <ProfileBuilderHeader form={form} />
      <Grid
        container
        spacing={2}
        sx={{
          // fill the remaining space but don't grow
          flex: 1,
          minHeight: 0,
        }}>
        <Grid item xs={4} md={4}>
          <ProfileBuilderFieldOutline />
        </Grid>
        <Grid item xs={8} md={8}>
          <Outlet />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProfileBuilderRoot;
